
import React from 'react';
import PageHeader from '../common/PageHeader';

const DashboardHeader = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'overview', label: 'Network Overview' },
    { id: 'segments', label: 'Segment Analysis' },
    { id: 'trade', label: 'Trade Area Intelligence' },
    { id: 'campaigns', label: 'Campaign Management' }
  ];
  
  return (
    <PageHeader 
      pageTitle="Executive View" 
      mainTitle="Performance Dashboard"
      description="Monitor key business metrics and performance indicators"
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default DashboardHeader;
